import * as React from "react";
import { getPrintDate, handleYesNo } from "../detail/form_utility";
import { SectionWrapper } from "./index";
import { IRootState } from "../../reducers";
import { connect } from "react-redux";

class QmuformPreviewComponent extends React.Component<any, any> {
  public render() {
    const { values } = this.props.mainForm.mainForm;
    const solutionOwner = this.getSolutionOwner();
    const solutionTeam = this.getSolutionTeam();
    return (
      <SectionWrapper>
        <div className="PrintSectionHeader">QMU</div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Centre to handle complaint:</div>
            <div className="PrintItemValue">
              {values.qmus[0].centreToHandleComplaint}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Solution owner:</div>
            <div className="PrintItemValue">{solutionOwner}</div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Solution team:</div>
            <div className="PrintItemValue">{solutionTeam}</div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Validated as a complaint:</div>
            <div className="PrintItemValue">
              {handleYesNo(values.qmus[0].validatedAsComplaint)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Validated Date:</div>
            <div className="PrintItemValue">
              {values.qmus[0].validatedDate ? getPrintDate(values.qmus[0].validatedDate) : '--'}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Recurrent:</div>
            <div className="PrintItemValue">
              {handleYesNo(values.qmus[0].recurrent)}
            </div>
          </div>
        </div>

        <div className="PrintContainerWrapper commentWrapper">
          <div className="PrintCommentContainer">
            <div className="PrintCommentLabel">Case comments:</div>
            <div className="PrintCommentValue">
              {values.qmus[0].caseComments}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">OER:</div>
            <div className="PrintItemValue">
              {handleYesNo(values.qmus[0].oer)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Correction(s) identified:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].correctionIdentified)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Correction(s):</div>
            <div className="PrintItemValue">{values.qmus[0].correction}</div>
          </div>
        </div>
        <div className="PrintContainerWrapper commentWrapper">
          <div className="PrintCommentContainer">
            <div className="PrintCommentLabel">
              Case comments for correction(s) identified:
            </div>
            <div className="PrintCommentValue">
              {values.qmus[0].caseCommentsCi}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper extra-margin">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Correction(s) completed:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].correctionCompleted)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper commentWrapper">
          <div className="PrintCommentContainer">
            <div className="PrintCommentLabel">Root cause anyalsis:</div>
            <div className="PrintCommentValue">
              {values.qmus[0].rootCauseAnalysis}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">
              Corrective action(s) identified:
            </div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].correctiveActionIdentified)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper commentWrapper">
          <div className="PrintCommentContainer">
            <div className="PrintCommentLabel">Corrective action(s):</div>
            <div className="PrintCommentValue">
              {values.qmus[0].correctiveAction}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper commentWrapper">
          <div className="PrintCommentContainer">
            <div className="PrintCommentLabel">
              Case comments for corrective action(s) identified:
            </div>
            <div className="PrintCommentValue">
              {values.qmus[0].caseCommentsCc}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper extra-margin">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">
              Corrective action(s) completed:
            </div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].correctiveActionCompleted)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">OER number:</div>
            <div className="PrintItemValue">{values.qmus[0].oernumber}</div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Financial loss to SD:</div>
            <div className="PrintItemValue">
              {values.qmus[0].financialLossToSd}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Being drafted:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].beingDrafted)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Sent DO for pre-approval:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].sentDoforPreapproval)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Pre-approved by DO:</div>
            <div className="PrintItemValue">
              {values.qmus[0].preapprovedByDo}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Circulated for comments:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].circulatedForComments)}
            </div>
          </div>
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Circulated for signatures:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].circulatedForSignatures)}
            </div>
          </div>
        </div>
        <div className="PrintContainerWrapper">
          <div className="PrintItemContainer">
            <div className="PrintItemLabel">Signed:</div>
            <div className="PrintItemValue">
              {getPrintDate(values.qmus[0].signed)}
            </div>
          </div>
        </div>
      </SectionWrapper>
    );
  }

  private getSolutionOwner = () => {
    const { values } = this.props.mainForm.mainForm;
    const qmuData = values.qmus[0];
    let solutionOwner = "";
    if (qmuData) {
      if (qmuData.solutionOwner) {
        if (qmuData.solutionOwner.length === 0) {
          solutionOwner = "";
        } else {
          solutionOwner = qmuData.solutionOwner
            .map((item: any) => item.value)
            .toString();
        }
      }
    }

    return solutionOwner;
  };

  private getSolutionTeam = () => {
    const { values } = this.props.mainForm.mainForm;
    const qmuData = values.qmus[0];
    let solutionTeam = "";
    if (qmuData) {
      if (qmuData.solutionTeam) {
        if (qmuData.solutionTeam.length === 0) {
          solutionTeam = "";
        } else {
          solutionTeam = qmuData.solutionTeam
            .map((item: any) => item.value)
            .toString();
        }
      }
    }

    return solutionTeam;
  };
}

// export default QmuformPreviewComponent;
const mapStateToProps = (state: IRootState) => {
  return {
    mainForm: state.form,
  };
};

// connect the form wrapper to the state store
export default connect(mapStateToProps, null)(QmuformPreviewComponent);
